import { render, staticRenderFns } from "./ComparisonFilterNoCaption.vue?vue&type=template&id=39a2fb84&"
import script from "./ComparisonFilterNoCaption.vue?vue&type=script&lang=js&"
export * from "./ComparisonFilterNoCaption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ComparisonFilterNoCaption.vue"
export default component.exports